import React, { useState, useEffect, useRef, useContext, ComponentProps, ReactNode } from "react";
import { Card, InputNumber, Row, Col, Input, DatePicker, Button, Table, Form, message, Select, Checkbox, Popconfirm, Space, FormInstance } from "antd";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../../../api/axiosInstance";
import dayjs from "dayjs";
import FileUpload, { FileUploadRef } from "../../../../components/file-input/FileUpload";
import OAuthProvider from "../../../../utils/OAuth/OAuthProvider";
import { AccountType } from "../../../../utils/common/Enum";
import { ColumnsType } from "antd/es/table";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { ScoreEditHistory } from "../../../../services/score-edit-hstories/score-edit-history";
import { InputRef } from 'antd'; // 👈 import đúng kiểu ref

const { TextArea } = Input;
const { Option } = Select;
const API_URL = process.env.REACT_APP_API_URL;
interface EditableCellProps {
    title: ReactNode;
    editable: boolean;
    children: ReactNode;
    dataIndex: string;
    record: any;
    handleSave: (record: any) => void;
    editing?: boolean;
}
const UserDetailManagement: React.FC = () => {
    const { userId } = useParams();
    const [formUserInfor] = Form.useForm();
    const navigate = useNavigate();
    const [scoreEditHistory, setScoreEditHistory] = useState<any>();

    const fileUploadRef = useRef<FileUploadRef>(null);
    const [imagePath, setImagePath] = useState<string>();
    const [hasNewImage, setHasNewImage] = useState(false);
    const [isEditPoint, setIsEditPoint] = useState(false);
    const [editingKey, setEditingKey] = useState<string | null>(null);
    const [originalRecord, setOriginalRecord] = useState<ScoreEditHistory | null>(null);

    const isEditing = (record: ScoreEditHistory) => record.id === editingKey;

    const location = useLocation();

    const EditableContext = React.createContext<FormInstance<any> | null>(null);

    const EditableRow = ({ index, ...props }: ComponentProps<any>) => {
        const [form] = Form.useForm();
        return (
            <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                    <tr {...props} />
                </EditableContext.Provider>
            </Form>
        );
    };

    const EditableCell: React.FC<EditableCellProps> = ({
        title,
        editable,
        children,
        dataIndex,
        record,
        handleSave,
        editing,
        ...restProps
    }) => {
        const inputRef = useRef<InputRef>(null);
        const form = useContext(EditableContext);


        useEffect(() => {
            if (editing && form) {
                form.setFieldsValue({ [dataIndex]: record[dataIndex] }); // <-- set giá trị vào form
                inputRef.current?.focus();
            }
        }, [editing, dataIndex, record, form]);

        const save = async () => {
            if (!form) return;
            try {
                const values = await form.validateFields();
                handleSave({ ...record, ...values });
            } catch (errInfo) {
                console.log("Lỗi khi lưu:", errInfo);
            }
        };

        let childNode = children;

        if (editable) {
            childNode = editing ? (
                <Form.Item name={dataIndex} style={{ margin: 0 }}>
                    <Input ref={inputRef} onPressEnter={save} />
                </Form.Item>
            ) : (
                <div onClick={() => { }} style={{ cursor: "default" }}>
                    {children}
                </div>
            );
        }

        return <td {...restProps}>{childNode}</td>;
    };

    const columns: ColumnsType<any> = [
        {
            title: "Ngày sửa điểm",
            dataIndex: "createdDate",
            key: "createdDate",
            render: (val: string) => new Date(val).toLocaleString(),
            width: 200,
        },
        {
            title: "Ngày cập nhật sửa điểm",
            dataIndex: "modifiedDate",
            key: "modifiedDate",
            render: (val: string) => {
                return val ? new Date(val).toLocaleString() : "";
            }, width: 200,
        },
        {
            title: "Giá trị cũ",
            dataIndex: "oldValues",
            key: "oldValues",
            width: 200,
            render: (val: any) => (
                <div>
                    <div><strong>Điểm tích luỹ:</strong> {val?.AccumulatedPoint}</div>
                    <div><strong>Điểm đơn:</strong> {val?.Point}</div>
                    <div><strong>Điểm đôi:</strong> {val?.DoublePoint}</div>
                </div>
            )
        },
        {
            title: "Giá trị mới",
            dataIndex: "newValues",
            key: "newValues",
            width: 200,
            render: (val: any) => (
                <div>
                    <div><strong>Điểm tích luỹ:</strong> {val?.AccumulatedPoint}</div>
                    <div><strong>Điểm đơn:</strong> {val?.Point}</div>
                    <div><strong>Điểm đôi:</strong> {val?.DoublePoint}</div>
                </div>
            )
        },
        {
            title: "Nội dung",
            dataIndex: "content",
            key: "content",
            editable: true,
        },
        {
            title: "Hành động",
            key: "action",
            width: 200,
            render: (_: any, record: ScoreEditHistory) => {
                const editable = isEditing(record);
                return editable ? (
                    <Space>
                        {/* <Button
                            type="link"
                            onClick={() => handleSaveScoreEdit(record)}
                            style={{ padding: 0 }}
                        >
                            Lưu
                        </Button> */}

                        <Popconfirm
                            title="Bạn có chắc muốn huỷ chỉnh sửa?"
                            okText="Có"
                            cancelText="Không"
                            onConfirm={cancelEditing}
                        >
                            <Button type="link" danger style={{ padding: 0 }}>
                                Huỷ
                            </Button>
                        </Popconfirm>
                    </Space>
                ) : (
                    <Space>
                        <Button
                            icon={<EditOutlined />}
                            onClick={() => handleEditScoreEditHistory(record)}
                            disabled={editingKey !== null && editingKey !== record.id}
                        />
                        <Popconfirm
                            title="Bạn có chắc chắn muốn xóa?"
                            onConfirm={() => handleDeleteScoreEditHistory(record.id as string)}
                            okText="Có"
                            cancelText="Không"
                        >
                            <Button icon={<DeleteOutlined />} danger />
                        </Popconfirm>
                    </Space>
                );
            }


        }
    ].map((col) => {
        if (!col.editable) return col;
        return {
            ...col,
            onCell: (record: ScoreEditHistory) => ({
                record,
                editable: col.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSaveScoreEdit,
                editing: isEditing(record),
            }),
        };
    });

    const handleCancel = () => {
        if (location.state?.from) {
            navigate(location.state.from, {
                state: {
                    restoreFilter: location.state.filter,
                    scrollY: location.state.scrollY
                }
            });
        } else {
            navigate(-1);
        }
    };
    const isSuperAdmin = OAuthProvider.getSession()?.accountType === AccountType.Admin;
    const handleUploadSuccess = (newPath: string) => {
        setImagePath(newPath);
        setHasNewImage(false);
    };

    const handleUpload = async (): Promise<string | null> => {
        if (hasNewImage) {
            return await fileUploadRef.current?.uploadFile() || null;
        }
        return imagePath?.toString() ?? null;
    };
    useEffect(() => {
        if (userId) {
            fetchUser();
            fetchScoreEditHistory();
        }
        const observer = new ResizeObserver(() => { });
        return () => observer.disconnect(); // Cleanup khi component unmount
    }, [userId]);

    const fetchUser = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/user/${userId}`);
            const user = response.data;
            setImagePath(user.avatarUser)
            formUserInfor.setFieldsValue({
                id: user.id,
                fullName: user.fullName,
                userName: user.userName,
                pointType: user.pointType,
                email: user.email,
                userCode: user.userCode,
                phoneNumber: user.phoneNumber,
                address: user.address,
                nickName: user.nickName,
                point: user.point ?? 0,
                doublePoint: user.doublePoint ?? 0,
                minPoint: user.minPoint ?? 0,
                accumulatedPoint: user.accumulatedPoint ?? 0,
                dateOfBirth: user.dateOfBirth ? dayjs(user.dateOfBirth) : null,
                updatePointDate: user.updatePointDate ? dayjs(user.updatePointDate) : null,
                gender: user.gender,
                isActive: user.isActive,
                avaterUser: user.avaterUser,
                note: user.note,
                guarantor: user.guarantor,
                racketUse: user.racketUse,
                shoesUse: user.shoesUse,
                favoriteBall: user.favoriteBall,
                accountType: user.accountType
            });
        } catch (error) {
            message.error("Không thể tải thông tin của người dùng!");
        }
    };

    const fetchScoreEditHistory = async () => {
        try {
            const response = await axiosInstance.get(`${API_URL}/v1/score-edit-histories/score-edit-history-by-user/${userId}`);
            setScoreEditHistory(response.data);
        } catch (error) {
            console.error("Không thể tải thông tin lịch sử sửa điểm người dùng!");
        }
    }

    const handleConfirm = async () => {
        try {
            const newImagePath = await handleUpload();

            const values = formUserInfor.getFieldsValue();
            const payLoad = {
                id: userId,
                nickname: values.nickname,
                userCode: values.userCode,
                fullName: values.fullName,
                nickName: values.nickName,
                userName: values.userName,
                email: values.email,
                pointType: values.pointType,
                phoneNumber: values.phoneNumber,
                address: values.address,
                gender: values.gender,
                isActive: values.isActive,
                dateOfBirth: values.dateOfBirth ? values.dateOfBirth.format("YYYY-MM-DD") : null,
                updatePointDate: values.updatePointDate ? values.updatePointDate.format("YYYY-MM-DD") : null,
                point: values.point,
                doublePoint: values.doublePoint,
                minPoint: values.minPoint,
                accumulatedPoint: values.accumulatedPoint,
                note: values.note,
                guarantor: values.guarantor,
                racketUse: values.racketUse,
                shoesUse: values.shoesUse,
                favoriteBall: values.favoriteBall,
                avatarUser: newImagePath,
                accountType: values.accountType,
                isEditPoint: isEditPoint,
                contentEditPoint: values.contentEditPoint
            };

            await axiosInstance.put(`${API_URL}/v1/user/update-user-admin/`, payLoad);

            message.success("Cập nhật người dùng thành công!");

            if (location.state?.from) {
                navigate(location.state.from, {
                    state: {
                        restoreFilter: location.state.filter,
                        scrollY: location.state.scrollY
                    }
                });
            } else {
                navigate(-1);
            }
        }
        catch (error: any) {
            message.error(error?.response.data.data);
        }
    };

    const handleEditScoreEditHistory = (record: ScoreEditHistory) => {
        setOriginalRecord({ ...record } as ScoreEditHistory);
        const newData = scoreEditHistory.map((item: any) => ({
            ...item,
            isEditing: item.id === record.id,
        }));
        setScoreEditHistory(newData);
        setEditingKey(record.id ?? "");
    };

    const handleSaveScoreEdit = async (row: ScoreEditHistory) => {
        const newData = [...scoreEditHistory];
        const index = newData.findIndex(item => row.id === item.id);
        if (index > -1) {
            const item = newData[index];
            newData.splice(index, 1, { ...item, ...row, isEditing: false });
            setScoreEditHistory(newData);
            setEditingKey(null);
            // Nếu cần gọi API lưu backend:
            await axiosInstance.put(`${API_URL}/v1/score-edit-histories/update-score-edit-history?ID=${row.id}`, row);
            message.success("Cập nhật lịch sử sửa điểm người dùng thành công!");
        }
    };

    const cancelEditing = () => {
        if (!originalRecord) return;
        const newData = scoreEditHistory.map((item: any) =>
            item.id === originalRecord.id ? { ...originalRecord, isEditing: false } : { ...item, isEditing: false }
        );
        setScoreEditHistory(newData);
        setEditingKey(null);
        setOriginalRecord(null); // reset
    };

    const handleDeleteScoreEditHistory = async (id: string) => {
        try {
            await axiosInstance.delete(`${API_URL}/v1/score-edit-histories/delete-score-edit-history/${id}`);
            message.success("Xóa lịch sử sửa điểm người dùng thành công!");
            fetchScoreEditHistory();
        } catch (error) {
            message.error("Không thể xóa lịch sử sửa điểm người dùng!");
        }
    }

    return (
        <div style={{ padding: "20px" }}>
            <Form layout="vertical" form={formUserInfor}>
                <Card style={{ borderRadius: "16px" }}>
                    <div className="p-6 bg-white rounded-lg shadow-md">
                        <h3 className="text-lg font-semibold mb-4">Thông tin chung vận động viên</h3>
                        <Row gutter={16}>
                            <Col span={4} className="flex justify-center items-center">
                                <div style={{ width: 200, height: 200 }}>
                                    <FileUpload width={200} height={200} ref={fileUploadRef} unit="user" type="avatar" initialFilePath={imagePath} onUploadSuccess={handleUploadSuccess} onFileSelected={() => setHasNewImage(true)} />
                                </div>
                            </Col>
                            <Col span={20}>
                                <Row gutter={16}>
                                    <Col span={4}>
                                        <Form.Item label="UserName" name="userName" rules={[
                                            { required: true, message: 'Vui lòng nhập user name' }                                           
                                        ]}>
                                            <Input placeholder="Nhập user name" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={4}>
                                        <Form.Item label="Mã người dùng" name="userCode" rules={[
                                            { required: true, message: 'Vui lòng nhập mã người dùng' },
                                            { min: 6, max: 6, message: 'Mã phải đúng 6 ký tự' },
                                        ]}>
                                            <Input placeholder="Nhập mã người dùng" maxLength={6} minLength={6} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Họ và tên" name="fullName">
                                            <Input placeholder="Nhập họ và tên" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Nickname" name="nickName" rules={[
                                            { required: true, message: 'Vui lòng nhập nickname' }]}>
                                            <Input placeholder="Nhập nickname" />
                                        </Form.Item>
                                    </Col>

                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label="Số điện thoại" name="phoneNumber">
                                            <Input placeholder="Nhập số điện thoại" maxLength={10} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Email" name="email">
                                            <Input placeholder="Nhập email" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Giới tính" name="gender">
                                            <Select placeholder="Chọn giới tính">
                                                <Option value={0}>Nam</Option>
                                                <Option value={1}>Nữ</Option>
                                                <Option value={2}>Khác</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label="Ngày sinh" name="dateOfBirth">
                                            <DatePicker placeholder="Chọn ngày sinh" format="DD/MM/YYYY" style={{ width: "100%" }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={16}>
                                        <Form.Item label="Địa chỉ" name="address">
                                            <Input placeholder="Nhập địa chỉ" />
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Checkbox checked={isEditPoint} onChange={(e) => setIsEditPoint(e.target.checked)}>
                                            Sửa điểm
                                        </Checkbox>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Điểm tích luỹ" name="accumulatedPoint">
                                            <InputNumber placeholder="Nhập điểm tích luỹ" type="number"
                                                style={{ width: "100%" }}
                                                min={100}
                                                step={10}
                                                disabled={!isEditPoint} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Điểm đơn" name="point">
                                            <InputNumber placeholder="Nhập điểm đơn" type="number"
                                                style={{ width: "100%" }}
                                                min={100}
                                                step={10}
                                                disabled={!isEditPoint} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Điểm đôi" name="doublePoint">
                                            <InputNumber placeholder="Nhập điểm đôi" type="number"
                                                style={{ width: "100%" }}
                                                min={100}
                                                step={10}
                                                disabled={!isEditPoint}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Điểm min" name="minPoint">
                                            <InputNumber placeholder="Nhập điểm min" type="number"
                                                style={{ width: "100%" }}
                                                min={100}
                                                step={10}
                                                disabled={!isEditPoint}/>
                                        </Form.Item>
                                    </Col>
                                     {isEditPoint && (
                                    <Col span={24}>
                                        <Form.Item label="Nội dung sửa điểm" name="contentEditPoint">
                                            <TextArea rows={4} placeholder="Nhập nội dung sửa điểm" />
                                        </Form.Item>
                                    </Col>)}
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label="Ngày cập nhật điểm" name="updatePointDate">
                                            <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} disabled />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Người bảo lãnh điểm" name="guarantor">
                                            <Input placeholder="Nhập tên người bảo lãnh điểm" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Loại điểm" name="pointType">
                                            <Select placeholder="Chọn loại điểm" defaultValue={1}>
                                                <Option value={1}>Điểm cam</Option>
                                                <Option value={2}>Điểm xanh</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label="Thông tin vợt" name="racketUse">
                                            <TextArea rows={2} placeholder="Nhập tối đa 500 kí tự" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Thông tin giày" name="shoesUse">
                                            <TextArea rows={2} placeholder="Nhập tối đa 500 kí tự" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="Loại bóng ưu thích" name="favoriteBall">
                                            <TextArea rows={2} placeholder="Nhập tối đa 500 kí tự" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={24}>
                                        <Form.Item label="Thành tích" name="note">
                                            <TextArea rows={4} placeholder="Nhập tối đa 500 kí tự" maxLength={500} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={16}>
                                    <Col span={8}>
                                        <Form.Item label="Trạng thái hoạt động" name="isActive">
                                            <Select defaultValue={true}>
                                                <Option value={true}>Đang hoạt động</Option>
                                                <Option value={false}>Không hoạt động</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} >
                                        <Form.Item label="Loại tài khoản" name="accountType">
                                            <Select defaultValue={2} disabled={!isSuperAdmin}>
                                                <Option visible={isSuperAdmin} value={0}>Admin</Option>
                                                <Option value={1}>Mod</Option>
                                                <Option value={2}>Người dùng</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <div style={{ display: "flex", justifyContent: "end", marginTop: 16, marginRight: 20 }}>
                        <Button style={{ marginRight: 10, backgroundColor: "#fff", borderColor: "#F48100", color: "#F48100" }} onClick={handleCancel}>Huỷ</Button>
                        <Button style={{ marginBottom: 10, backgroundColor: "#F48100", borderColor: "#F48100" }} type="primary" onClick={handleConfirm}>Xác nhận</Button>
                    </div>
                </Card >

    <Card title="Lịch sử thay đổi điểm" style={{ marginTop: 16, borderRadius: "16px" }}>
        <Table
            components={{
                body: {
                    row: EditableRow,
                    cell: EditableCell,
                },
            }}
            rowClassName={() => 'editable-row'}
            bordered
            columns={columns}
            dataSource={scoreEditHistory}
            pagination={false}
            scroll={{ y: 30 * 10 }}
        />
    </Card>
            </Form >

        </div >

    );
};

export default UserDetailManagement;